// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"uR-z","inlineTitle":"vR-z","sponsoredAdsWrapper":"wR-z","marketplaceRecosWrapper":"xR-z"};